/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Update_Team_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update team permissions. Please try again." |
*
* @param {Spaces_Update_Team_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_update_team_error = /** @type {((inputs?: Spaces_Update_Team_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Update_Team_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Aktualisieren der Team-Berechtigungen. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to update team permissions. Please try again.")
});